import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/layout/images/logo-footer.svg")